import dayjs from "dayjs";
import moment from "moment";

export const toSentenceCase = (camelCase) => {
  if (camelCase) {
    const result = camelCase.replace(/([A-Z])/g, " $1");
    return result[0].toUpperCase() + result.substring(1).toLowerCase();
  }
  return "";
};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export function getDisplayTime(time) {
  let a = moment(moment(time, "YYMMDDHHmmssSSS").toDate()).format("YYYY/MM/DD");
  let b = moment(moment(time, "YYMMDDHHmmssSSS").toDate()).format("HH:mm:ss");
  return `${a}\n${b}`;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formatTime(time, date) {
  return date.format("MMMM DD, YYYY") + ", " + time.format("h:mm a");
}
export function combineDateTime(time, date) {
  return dayjs(
    `${date.format("YYYY-MM-DD")}T${time.format("HH:mm:ss")}`
  ).toDate();
}
